import React, { useCallback, useEffect } from "react";
import { observer } from "mobx-react";
import { Alert, AlertIcon, Box, Button } from "@chakra-ui/react";
import { Container, LoginTitle } from "./styled";
import { Link } from "react-router-dom";
import { getUrlParams } from "../../services/utils";
import { mainTheme } from "../../config/theme";
import { useStores } from "../../hooks/useStores";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

// TODO: Style page
export const StripeSuccess: React.FC = observer(() => {
  const { session } = useStores();

  const getStripeSession = useCallback(async () => {
    const params = getUrlParams(window.location.hash);
    const sessionId = params["session_id"];

    // TEST sessioID : cs_test_a1zwZ3uRVkWq6msxgmZsHlZ29tiulgiAPgiTmkbr2mZPNyLPMu4rjCn7Kz
    if (sessionId) {
      await session.stripeSessionCheckout(sessionId);
    }
  }, [session]);

  useEffect(() => {
    session.initialize();
    ReactGA.event({
      category: "Customer",
      action: "Iscrizione Abbonamento",
    });
    document.addEventListener("DOMContentLoaded", getStripeSession);
  }, [getStripeSession, session]);

  //console.log(session.stripeSessionCheckoutError);
  useEffect(() => {
    // ReactGA.pageview("/stripe-checkout-success");
    ReactGA.event({
      category: "Customer",
      action: "Iscrizione Abbonamento",
    });
    ReactPixel.track("Iscrizione Abbonamento");
  }, []);

  return (
    <Container>
      <Box
        boxShadow=" 0px 0px 20px rgba(51, 102, 255, 0.15)"
        p="32px"
        rounded="32px"
        bg="white"
        minH="200px"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <div style={{ textAlign: "center", width: "400px" }}>
          <LoginTitle>Gestione abbonamento</LoginTitle>
        </div>
        <div>
          <Alert status={"success"} borderRadius={"5px"} margin={"2rem 0"}>
            <AlertIcon />
            Abbonamento attivato correttamente!
          </Alert>
          {/* {session.stripeSessionCheckoutError && (
            <Alert
              status={"error"}
              color={mainTheme.colors.danger}
              borderRadius={"5px"}
              margin={"2rem 0"}
            >
              <AlertIcon />
              Error stripe checkout session
            </Alert>
          )} */}
          <Link to="/client/profile">Torna al profilo</Link>
        </div>
      </Box>
    </Container>
  );
});
